import React, { useEffect } from "react"
import { IconButton } from "theme-ui"
import "assets/css/modal.css"
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose"

const Modal = ({ handleClose, show, children }) => {
    const showHideClassName = show
        ? "modal display-block"
        : "modal display-none"

    useEffect(() => {
        if (show) {
            document.body.classList.add("noscroll")
        }

        return () => {
            document.body.classList.remove("noscroll")
        }
    })

    return (
        <div className={showHideClassName}>
            <div className="modal-wrapper">
                <section className="modal-main">
                    {children}
                    <IconButton
                        color="primary"
                        sx={{ fontSize: 5 }}
                        onClick={handleClose}
                    >
                        <IoMdClose />
                    </IconButton>
                </section>
            </div>
        </div>
    )
}

export default Modal
